// Messages for portal/shipments/DocumentUploadModal (auto-merged by lib/i18n.ts).
export const en = {
  'portal.doc_upload.title': 'Upload document',
  'portal.doc_upload.cancel': 'Cancel',
  'portal.doc_upload.upload': 'Upload',
  'portal.doc_upload.intro':
    'The document is shared with Geo4Logistics operations for this shipment.',
  'portal.doc_upload.file': 'File',
  'portal.doc_upload.title_label': 'Title (optional)',
  'portal.doc_upload.title_aria': 'Title',
  'portal.doc_upload.title_placeholder': 'Defaults to the file name',
  'portal.doc_upload.type': 'Type',
  'portal.doc_upload.type_aria': 'Document type',
  'portal.doc_upload.type.hbl': 'HBL',
  'portal.doc_upload.type.invoice': 'Invoice',
  'portal.doc_upload.type.packing': 'Packing',
  'portal.doc_upload.type.customs': 'Customs',
  'portal.doc_upload.type.other': 'Other',
}

export const zhTW = {
  'portal.doc_upload.title': '上傳文件',
  'portal.doc_upload.cancel': '取消',
  'portal.doc_upload.upload': '上傳',
  'portal.doc_upload.intro': '此文件將就此貨件與 Geo4Logistics 營運團隊共享。',
  'portal.doc_upload.file': '檔案',
  'portal.doc_upload.title_label': '標題（選填）',
  'portal.doc_upload.title_aria': '標題',
  'portal.doc_upload.title_placeholder': '預設為檔案名稱',
  'portal.doc_upload.type': '類型',
  'portal.doc_upload.type_aria': '文件類型',
  'portal.doc_upload.type.hbl': 'HBL',
  'portal.doc_upload.type.invoice': '發票',
  'portal.doc_upload.type.packing': '裝箱單',
  'portal.doc_upload.type.customs': '報關',
  'portal.doc_upload.type.other': '其他',
}
